var exports = {
  "e6": "ChannelItem.module__channelItemCore___dENrOE",
  "$H": "ChannelItem.module__channelItemCoreSelected___dENrOE",
  "_B": "ChannelItem.module__channelItemCoreUnselected___dENrOE",
  "Vp": "ChannelItem.module__channelItemCoreHovered___dENrOE",
  "TV": "ChannelItem.module__typingTooltip___dENrOE",
  "kp": "ChannelItem.module__channelTypingIndicator___dENrOE",
  "IM": "ChannelItem.module__typingIndicatorIcon___dENrOE",
  "U4": "ChannelItem.module__channelItemSelected___dENrOE",
  "OI": "ChannelItem.module__typingAvatars___dENrOE",
  "_N": "ChannelItem.module__channelItemIcon___dENrOE",
  "Jz": "ChannelItem.module__channelItemIconSelected___dENrOE",
  "Wk": "ChannelItem.module__categoryContainer___dENrOE",
  "yb": "ChannelItem.module__categoryName___dENrOE",
  "zc": "ChannelItem.module__iconContainer___dENrOE",
  "HA": "ChannelItem.module__channelName___dENrOE",
  "Hq": "ChannelItem.module__actionsContainer___dENrOE",
  "OO": "ChannelItem.module__channelItemIconUnselected___dENrOE",
  "Cr": "ChannelItem.module__channelItemIconHighlight___dENrOE",
  "rC": "ChannelItem.module__channelItemLabel___dENrOE",
  "gw": "ChannelItem.module__channelItemActions___dENrOE",
  "kL": "ChannelItem.module__container___dENrOE",
  "YI": "ChannelItem.module__channelReorderTarget___dENrOE",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___dENrOE",
  "XE": "ChannelItem.module__unreadIndicator___dENrOE",
  "_j": "ChannelItem.module__unreadIndicatorMuted___dENrOE",
  "fc": "ChannelItem.module__channelItem___dENrOE",
  "Z$": "ChannelItem.module__channelItemCategory___dENrOE",
  "RQ": "ChannelItem.module__channelItemRegular___dENrOE",
  "zx": "ChannelItem.module__channelItemHighlight___dENrOE",
  "_R": "ChannelItem.module__channelItemMuted___dENrOE",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___dENrOE",
  "Fb": "ChannelItem.module__channelItemHoverable___dENrOE",
  "FN": "ChannelItem.module__channelItemPressed___dENrOE",
  "Je": "ChannelItem.module__channelItemOver___dENrOE",
  "X9": "ChannelItem.module__channelItemContextMenu___dENrOE",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___dENrOE",
  "GJ": "ChannelItem.module__channelItemDragging___dENrOE",
  "rO": "ChannelItem.module__channelItemDimmed___dENrOE",
  "x1": "ChannelItem.module__channelItemMutedState___dENrOE",
  "Ef": "ChannelItem.module__hoverAffordance___dENrOE",
  "Mn": "ChannelItem.module__keyboardFocus___dENrOE",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___dENrOE",
  "Yq": "ChannelItem.module__categoryContent___dENrOE",
  "Yl": "ChannelItem.module__categoryIcon___dENrOE",
  "Sk": "ChannelItem.module__createChannelButton___dENrOE",
  "$Z": "ChannelItem.module__createChannelIcon___dENrOE",
  "Ne": "ChannelItem.module__voiceUserCount___dENrOE",
  "p9": "ChannelItem.module__channelItemVoice___dENrOE",
  "pL": "ChannelItem.module__contextMenuOpen___dENrOE",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___dENrOE",
};

module.exports = exports;
